import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_88ntrh9ks5: FaireBrandEntity = {
  token: "b_88ntrh9ks5",
  type: "brand",
  name: "Stuzzi Hot Sauce",
  avatarUrl:
    "https://cdn.faire.com/fastly/856862d4214cd97aa427ec5b6c7391bcb337a1fadf43c080e40de7d9ad352627.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/a076a31e19802a0636894305d8cbafedd19dd3c1a5a709bac95a3ae3de1cc4e8.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/856862d4214cd97aa427ec5b6c7391bcb337a1fadf43c080e40de7d9ad352627.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/a076a31e19802a0636894305d8cbafedd19dd3c1a5a709bac95a3ae3de1cc4e8.jpeg",
  location: "New York, NY, USA",
  minimumOrderDollars: 100,
  rating: 4.3,
  reviewCount: 6,
  isInsider: true,
  description:
    "Tequila-and wine—makers Richard and Carla Betts met acclaimed chefs Ethel Hoon and Jakob Zeller while on an Alpine road trip. That night over drinks they quickly got down to the juice of life: the two couples shared the same love of travel, good food and fiery spice.  Hailing from North America, Singapore, and Italy, and having collectively worked in the restaurant industry for over 50 years, they realized they were uniquely qualified to create a hot sauce that would enhance as many cuisines as possible. \n",
  meta: {
    source: "api",
    importedAt: "2026-07-09T05:19:25.241Z",
    importedBy: "entity-db-cli",
  },
};
